import * as sentry from '../../src/utils/sentry'
import { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { IDB_logs } from '../IDB/IDB.dexie'
import { Cust_hasLogsDisabled } from '../Cust/Cust.serverPrefs'

export function Logg_createLogger(logGroupName: string) {
    return new ClientLogger({
        logGroupName,
        saveLog: async (log) => {
            if (Cust_hasLogsDisabled()) return

            try {
                await IDB_logs().add(log)
            } catch (error) {
                console.error(error) // eslint-disable-line
            }
        },
        reportError: (error, extra, tags) => sentry.sendToSentry(error, { extra, tags }),
        getHashPath,
    })
}

/**
 * Get a stable path for the route so we can find other similar logs at the same route
 */
function getHashPath() {
    try {
        // Treat the hash path like a real url
        const url = new URL(window.location.href.replace('/#/', '/'))

        // Remove the random key that react route adds
        url.searchParams.delete('_k')

        // Sort the order of the query params
        url.searchParams.sort()

        // Cut off the begining bit as it's different on different platforms
        return url.pathname + url.search
    } catch (error) {
        sentry.err(error, { extra: { href: window.location.href } })
    }
}
